// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__14GFJ","left":"StickyBox_left__2EaCU","right":"StickyBox_right__3Qjwa"};